<template>
  <div>
    <!-- Header -->
    <LoadingPage v-if="isLoadPage" />
    <!-- Page content -->
    <b-container class="py-7 py-lg-5 pt-lg-8">
      <!-- Table -->
      <b-row class="justify-content-center">
        <b-col lg="6" md="8" sm="12" class="mt-2">
          <h3 class="mx-3">สถานะของคุณ</h3>
          <CardHeader />
          <!-- todoList.showdailyPhoto = true -->
          <div class="my-4">
            <CardDailyTask 
              ref="dailyTask"
              v-show="!todoList.showdailyPhoto"
              :todoList="todoList"
              :visibleCamera.sync="visibleCamera" 
              :isLoadPage.sync="isLoadPage"
              @handleClickDailyPhotos="handleClickDailyPhotos"
              @getDailyPhotosDriver="getDailyPhotosDriver"
            />
          </div>
          <CardCurrentJobs 
            :search="search" 
            :items="items"
            @changePage="changePage($event)"
          />
          <div class="my-4">
            <CardDailyTask 
              ref="dailyTask"
              v-show="todoList.showdailyPhoto"
              :todoList="todoList"
              :visibleCamera.sync="visibleCamera"
              :isLoadPage.sync="isLoadPage" 
              @handleClickDailyPhotos="handleClickDailyPhotos"
              @getDailyPhotosDriver="getDailyPhotosDriver"
            />
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import jobServices from "@/api/job.service.js";
import empoyeeServices from "@/api/empoyee.service.js";
import CameraComponent from "@/components/CameraComponent.vue";
import CardHeader from "@/components/Home/CardHeader.vue";
import CardCurrentJobs from "@/components/Home/CardCurrentJobs.vue";
import CardDailyTask from "@/components/Home/CardDailyTask.vue";

export default {
  components: {
    CameraComponent,
    CardHeader,
    CardCurrentJobs,
    CardDailyTask,
  },
  data() {
    return {
      isLoadPage: false,
      todoList: {
        dailyPhotos: false,
        dailyPhotosURL: null,
        showdailyPhoto: false,
      },
      model: {
        email: "",
        password: "",
        rememberMe: false,
      },
      search: {
        page: 1,
        perPage: 10,
        totalItem: 0,
      },
      items: [],
      visibleCamera: false,
    };
  },
  mounted() {
    this.getDriverJob();
    this.getDailyPhotosDriver();
  },
  methods: {
    changePage(i) {
      if (this.search.page == i) return;
      this.search.page = i;
      this.getDriverJob();
    },
    handleClickDailyPhotos() {
      this.visibleCamera = !this.visibleCamera;
      if (this.todoList.dailyPhotos) {
        this.todoList.showdailyPhoto = true
      }else{
        this.todoList.showdailyPhoto = false
      }
    },
    async getDailyPhotosDriver() {
      try {
        this.isLoadPage = true;
        const res = await empoyeeServices.getDailyPhotos();
        const dailyPhotos = res.data; // เก็บข้อมูลใน state

        if (dailyPhotos.data) {
          this.todoList.dailyPhotos = true;
          this.todoList.dailyPhotosURL = dailyPhotos.data;
          this.todoList.showdailyPhoto = true
        } else {
          this.todoList.dailyPhotos = false;
        }
      } catch (error) {
        console.error("Error fetching daily photos:", error);
      } finally { this.isLoadPage = false; }
    },
    // toggleCamera() {
    //   this.$refs.cameraComponent.toggleComponentVisibility();
    // },
    async getDriverJob() {
      try{
        this.isLoadPage = true;
        console.log(this.search, 'this.search')
        const job = await jobServices.getDriverJob(this.search);
        const { items, meta } = job.data.data;
        this.items = items;
        this.search.page = meta.currentPage;
        this.search.totalItem = meta.totalItems;
      }catch(error){}
      finally{ this.isLoadPage = false; }
    },
    onSubmit() {
      // this will be called only after form is valid. You can do api call here to login
    },
  },
};
</script>
